import { render, staticRenderFns } from "./ShopLayout.vue?vue&type=template&id=1ab59bd1&scoped=true&"
import script from "./ShopLayout.vue?vue&type=script&lang=js&"
export * from "./ShopLayout.vue?vue&type=script&lang=js&"
import style0 from "./ShopLayout.vue?vue&type=style&index=0&id=1ab59bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab59bd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ab59bd1')) {
      api.createRecord('1ab59bd1', component.options)
    } else {
      api.reload('1ab59bd1', component.options)
    }
    module.hot.accept("./ShopLayout.vue?vue&type=template&id=1ab59bd1&scoped=true&", function () {
      api.rerender('1ab59bd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/ShopLayout.vue"
export default component.exports